import classNames from 'classnames';

import { ContentItemData } from './types';
import ButtonLink from '../../components/Button/ButtonLink';
import { Paragraph } from '../../components/Text';
import BulletedList from '../BulletedList';
import RawHtml from '../RawHtml';

import style from './content-item.module.css';

interface ContentItemProps {
  content: ContentItemData;
}

type ContentType =
  | 'Button'
  | 'List'
  | 'Paragraph'
  | 'Wysiwyg';

const ContentItem = ({
  content,
}: ContentItemProps) => {
  switch (content.type as ContentType) {
    case 'Button': {
      return (
        <ButtonLink
          buttonColor={content.button?.buttonColor}
          className={style.ctaButton}
          id={content.button?.buttonId ?? undefined}
          linkFragment={content.button?.button}
        />
      );
    }
    case 'List': {
      return (
        <>
          {content.list?.heading && (
            <Paragraph
              className={style.listHeading}
              fontSize={15}
              fontWeight={700}
            >
              {content.list.heading}
            </Paragraph>
          )}

          {!!content.list?.items.length && (
            <BulletedList
              className={style.list}
              dense={content.list.dense}
              items={content.list.items.map(item => item.text)}
            />
          )}
        </>
      );
    }
    case 'Paragraph': {
      return (
        <Paragraph
          className={classNames(
            style.paragraph,
            {
              [style.paragraphNoMarginTop]: content.paragraph?.removeTopMargin,
            },
          )}
          fontSize={content.paragraph?.largeFontSize ? 20 : 15}
          fontWeight={content.paragraph?.bold ? 700 : 400}
        >
          {content.paragraph?.text}
        </Paragraph>
      );
    }
    case 'Wysiwyg': {
      return (
        <RawHtml
          className={style.wysiwyg}
        >
          {content.wysiwyg?.wysiwyg ?? ''}
        </RawHtml>
      );
    }
  }
};

export default ContentItem;
